<script setup>
import Button from "@/Components/Buttons/Button.vue";
</script>

<template>
    <Button class="bg-red-600 text-white hover:brightness-90 transition-all duration-300">
        <slot />
    </Button>
</template>

<style scoped></style>
